import {Component, OnDestroy, OnInit} from '@angular/core';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {InvoiceService} from '../../Services/invoice.service';
import {ToastrService} from 'ngx-toastr';
import * as moment from 'moment';

@Component({
  selector: 'app-email-invoice-master-sheet',
  templateUrl: './email-invoice-master-sheet.component.html',
  styleUrls: ['./email-invoice-master-sheet.component.less']
})
export class EmailInvoiceMasterSheetComponent implements OnInit, OnDestroy {

  public fromDateTmp: moment.Moment = moment().subtract(1, 'months').set({'hour': 0, 'minute': 0, 'second': 0}).startOf('month').utc();
  public toDateTmp: moment.Moment = moment().subtract(1, 'months').set({'hour': 23, 'minute': 59, 'second': 59}).endOf('month').utc();

  public fromDate: any;
  public toDate: any;
  public toEmail = '';
  public isCommissionReport : boolean;

  constructor(
    public readonly modalService: NgbModal,
    private toasterService: ToastrService,
    private readonly invoiceService: InvoiceService
  ) {
  }

  public ngOnInit(): void {
    this.fromDate = this.fromDateTmp.format('YYYY-MM-DD');
    this.toDate = this.toDateTmp.format('YYYY-MM-DD');
  }

  public ngOnDestroy(): void {
    try {
      this.modalService.dismissAll();
    } catch (error) {

    }
  }

  public cancel(): void {
    this.modalService.dismissAll();
  }

  public save(): void {

    console.log(this.invoiceService.masterSheetFilter);

    this.invoiceService.sendMasterSheet(this.toEmail, this.fromDate, this.toDate, this.isCommissionReport).subscribe(res => {
        this.toasterService.success('Seed for MasterSheet Sent!');
        this.modalService.dismissAll();
      },
      err => this.toasterService.error('Error sending seed for MasterSheet', '', {disableTimeOut: true, closeButton: true}));
  }

  update(val: any) {

    if (val.property === 'fromDate') {
      this.fromDate = val.time;
    }

    if (val.property === 'toDate') {
      this.toDate = val.time;
    }
  }

}
